/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-09-12 14:23:05
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-12 16:46:56
 *  */

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RootThunkApi } from '../../../../app/store'
import { sendAsync } from '../../../../app/applicationSlice'
import { geMTSSettingList, getSubmitBatch } from '../../../../services/MedicalTechnologyStationSetting'


export const getSubmitBatchAsync = createAsyncThunk<void, any, RootThunkApi>(
  'dataPermision/getSubmitBatchAsync',
  async (body, api) => {
    return sendAsync(getSubmitBatch(body), api)
  }
)

export const geMTSSettingListAsync = createAsyncThunk<
  any,
  void,
  RootThunkApi
>('dataPermision/geMTSSettingListAsync', async (body, api) => {
  return sendAsync(geMTSSettingList(), api)
})
